export default "__VITE_ASSET___LD6hSqA__"